import { render } from "./ProductTemplate.vue?vue&type=template&id=29161c99"
import script from "./ProductTemplate.vue?vue&type=script&lang=js"
export * from "./ProductTemplate.vue?vue&type=script&lang=js"

import "./ProductTemplate.vue?vue&type=style&index=0&id=29161c99&lang=css"

import exportComponent from "/buddy/vue-calendar-bundle-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__